import { destinationGroups } from './destination-groups';

export const v4 = {
  destinationGroups,
};
